<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-12 font-custom-light min-h-screen">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-black" >

      <div class="container mx-auto px-4 max-w-7xl">


        <h3 class="text-3xl text-center font-bold">Confirmación de asistencia</h3>
        <h3 class="text-lg text-center mt-3 font-semibold">&bull; Completa tus datos y confirma tu asistencia. </h3>
        
        <br/>
        <h3 class="text-xl font-semibold text-center">Por favor completá el formulario en su totalidad</h3>



        <!-- Formulario -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-12/12 flex flex-col items-center">
            <div v-if="imageSrc" class="mt-4"> 
              <img :src="imageSrc" alt="Vista previa" class="max-w-full h-auto rounded-md shadow w-52 h-52" />
            </div> 
            <button class="mt-8 px-4 py-2 bg-transparent border border-black hover:bg-black text-black font-semibold hover:text-white rounded" @click="selectPhoto">TOMAR/SUBIR FOTO</button>
            <input ref="fileInput" type="file" accept="image/*" capture="environment" class="hidden" @change="handleFileInput"/>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>          
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">         
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Empresa" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Cargo" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
        
        </div>  

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
              <label class="block mb-1">País</label>
              <Dropdown v-model="selectedCountry" filter :options="paises" optionLabel="value" placeholder="Select a Country" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
              <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 gap-3 justify-center">
          <button type="submit" class="mt-8 px-4 py-2 bg-transparent border border-black hover:bg-black text-black font-semibold hover:text-white rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>CONFIRMAR ASISTENCIA
          </button>
        </div>

        <!--
        <div class="text-lg  pt-6">&bull; Si ya estas acreditado y no te llego el correo podes descargar tu credencial con el DNI haciendo <a class="font-semibold" href="/nplay/credencial">click aquí</a></div>
        -->
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import { useRoute } from 'vue-router'


import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'

import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado} from 'qreventos-suite/services';
import { VERIFICADO, UPDATE } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';


interface Pais {
  code: string;
  value: string;
}


export default defineComponent({
  components: {
    HeaderSection,
    InputText, Dropdown,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      acreditado: undefined as unknown as Acreditado,
      isSubmitting: false,
      paises: [] as Pais[],
      imageSrc: '', // Almacena la vista previa de la imagen
      imageBase64: '', // Almacena la imagen en formato base64
      selectedCountry: {"code": "+54", "value": "Argentina"} as Pais,
      formData: {
        nombre: '',
        apellido: '',
        mail: '',
        cargo:'',
        empresa: '',
        telefono: '',
        codigoArea: '',
        numeroTelefono: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingresá tu nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingresá tu apellido').min(3, 'Al menos 3 letras'),
        empresa: yup.string().required('Ingresá el nombre de la empresa').min(3, 'Al menos 3 letras'),
        cargo: yup.string().required('Ingresá tu cargo').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingresá tu correo').email('Correo inválido'),
        codigoArea: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        numeroTelefono: yup.string().required('Ingresá tu celular').matches(/^\d+$/, 'Solo se permiten números'),
      });      
    }
  },
  methods: {
    selectPhoto() {
      const fileInput = this.$refs.fileInput as HTMLInputElement;
      if (fileInput) {
        fileInput.click();
      }
    },
    handleFileInput(event:Event) {
      const input = event.target as HTMLInputElement;
      if (!input.files || input.files.length === 0) {
        return;
      }
        const file = input.files[0];
        if (file) {
          const reader = new FileReader();      
              reader.onload = (event: ProgressEvent<FileReader>) => {
                this.imageSrc = event.target?.result as string;
                this.imageBase64 =( event.target?.result as string).split(",")[1];
            };
          reader.readAsDataURL(file);
        }
      
    },
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        this.acreditado.estadoAcreditado.id = VERIFICADO;
        this.acreditado.nombre = this.formData.nombre
        this.acreditado.apellido = this.formData.apellido;
        this.acreditado.mail = this.formData.mail;
        this.acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        this.acreditado.empresa = this.formData.empresa;
        this.acreditado.cargo = this.formData.cargo;
        this.acreditado.notificar = true;
        this.acreditado.modificado = UPDATE;        

        this.acreditado.foto = this.imageBase64;

        await suiteService.saveOrUpdate(suiteConfig.evento, this.acreditado);

        this.isSubmitting = false;
        Swal.fire({
          title: "¡Ya estás confirmado!",
          html: "En breve te enviaremos un mail con tu acreditación.<br/><br/>Revisá tu casilla de correo y spam.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://www.nplay.convergencia.com";
        });
        

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  },
  async mounted() {
    this.paises = jsonCountries;

    const route = useRoute();
    const hash = route.params.hash as string;

    this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);
    
    console.log(this.acreditado);
    if(!this.acreditado) {
      Swal.fire({ title: "¡Atención!", html: "El acreditado no existe.", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }


    if (this.acreditado.tipoAcreditado.id != 2014 && this.acreditado.tipoAcreditado.id != 2017 && this.acreditado.tipoAcreditado.id != 2013) {
      Swal.fire({ title: "¡Atención!", html: "El acreditado no existe.", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    if (this.acreditado.estadoAcreditado.id == 2) {
      Swal.fire({ title: "¡Muchas gracias!", html: "Ya está confirmado para participar del evento.", icon: "success" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    this.formData.apellido = this.acreditado.apellido;
    this.formData.nombre = this.acreditado.nombre;
    this.formData.empresa = this.acreditado.empresa;
    this.formData.mail = this.acreditado.mail;
    this.formData.cargo = this.acreditado.cargo;

  }
});
</script>